import { templates } from '../../../services/api.admin';
import { fetchTableData, deleteTableData } from '../tables';
import { MODELS } from '../../../constants/admin/settings';
import { fetchModel, submit, fetchDependencies, onInput } from '../forms';
import { TABLE_INDICES } from '../../../constants/admin/tables';
import { currentPath } from '../../../selectors/router';
import { push } from 'react-router-redux';
import { pick } from 'lodash';
import { logoToBase64 } from '../../../selectors/admin/models/contracts';
import { ADMIN_TEMPLATES_NEW_PATH } from '../../../constants/routes';
import { transformContractText } from '../../../selectors/admin/models/contracts';

export function fetchTemplates(contextId, pagination) {
    return fetchTableData(
        contextId ? () => templates.getOrg(contextId, pagination) : () => templates.get(pagination),
        'templates',
        {
            pagination,
            tableIndex: TABLE_INDICES[MODELS.TEMPLATE]
        }
    );
}

export function fetchAllTemplates(contextId) {
    return fetchDependencies([contextId ? () => templates.getOrgAll(contextId) : templates.getAll], {
        append: true
    });
}

export function deleteTemplates() {
    return deleteTableData(templates.delete, MODELS.TEMPLATE, { tableIndex: TABLE_INDICES[MODELS.TEMPLATE] });
}

export function goToNewTemplate() {
    return (dispatch, getState) => {
        dispatch(push(`${currentPath(getState())}/${MODELS.TEMPLATE}s/new`));
    };
}

export function openTemplate(item) {
    return (dispatch, getState) => {
        dispatch(push(`${currentPath(getState())}/${MODELS.TEMPLATE}s/${item.id}`));
    };
}

export function create(data) {
    return submit(() => templates.create(_permitBody(data)), 'Template successfully created.');
}

export function update(data, id) {
    return submit(() => templates.update(id, _permitBody(data)), 'Template successfully updated.');
}

export function fetchMember(id) {
    return fetchModel(() => templates.getMember(id), MODELS.TEMPLATE, {
        transform: logoToBase64
    });
}

const _permitBody = data => {
    return pick(data, ['organizationId', 'data', 'type', 'logo', 'name', 'clearing']);
};

export function templateFromContract(content, type) {
    return dispatch => {
        dispatch(push(ADMIN_TEMPLATES_NEW_PATH));
        dispatch(onInput(MODELS.TEMPLATE, 'type', type, true));
        dispatch(onInput(MODELS.TEMPLATE, 'data', transformContractText(content), true));
    };
}



// WEBPACK FOOTER //
// ./src/actions/admin/models/templates.js